var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8021 14.6909V9.80204H10.1979V14.6909H11.8021ZM11.8021 17.9757V16.3333H10.1979V17.9757H11.8021ZM5.23264 8.15968C6.83681 6.55552 8.75926 5.75343 11 5.75343C13.2407 5.75343 15.1505 6.55552 16.7292 8.15968C18.3333 9.73839 19.1354 11.6481 19.1354 13.8888C19.1354 16.1296 18.3333 18.052 16.7292 19.6562C15.1505 21.2349 13.2407 22.0243 11 22.0243C8.75926 22.0243 6.83681 21.2349 5.23264 19.6562C3.65394 18.052 2.86458 16.1296 2.86458 13.8888C2.86458 11.6481 3.65394 9.73839 5.23264 8.15968Z",
    fill: "#D12600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.457aa40e75d63495214ef5898845b8f8.svg";
export { ForwardRef as ReactComponent };